import { render, staticRenderFns } from "./ShipGraphLogistics.vue?vue&type=template&id=75836c72&scoped=true&"
import script from "./ShipGraphLogistics.vue?vue&type=script&lang=js&"
export * from "./ShipGraphLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75836c72",
  null
  
)

export default component.exports